



























































































































import { defineComponent, PropType, reactive, ref, watch } from '@vue/composition-api';
import { ITableOptions } from '@/bundles/BaseTable/interfaces';
import { adHeadersData } from '@/bundles/Ad/helpers';
import { IAdCampaignItem } from '@/bundles/Ad/interfaces';
import { useAdCampaignItem } from '@/bundles/Ad/composables/useAdCampaignItem';
import { useTable } from '@/bundles/BaseTable/composables/useTable';

import BaseTable from '@/bundles/BaseTable/components/BaseTable.vue';
import AdItemEditForm from '@/bundles/Ad/components/AdItemEditForm.vue';

export default defineComponent({
  name: 'AdListTable',

  components: {
    BaseTable,
    AdItemEditForm,
  },

  props: {
    tableOptionsEntry: {
      type: Object as PropType<ITableOptions>,
      required: true
    },
    itemsEntry: {
      type: Array as PropType<Array<IAdCampaignItem>>,
      default: () => []
    },
    totalRowsEntry: {
      type: Number,
      default: 0
    },
    loading: Boolean,
    totals: {
      type: Object,
      default: () => ({})
    }
  },

  emits: ['options:change', 'items:refresh'],

  setup(props, { emit }) {
    const { calculateHeight } = useTable();

    function optionsChangeEventHandler(options: ITableOptions) {
      emit('options:change', options);
    }

    function calculateCtr (item: IAdCampaignItem) {
      if (!item.impressions) {
        return 0;
      }
      const value = item.clicks / item.impressions * 100;
      return parseFloat(value.toString()).toFixed(3);
    }

    const photoDialog = reactive({ show: false, url: '' });
    function openPhotoDialog (item: IAdCampaignItem) {
      photoDialog.show = true;
      photoDialog.url = item.image;
    }


    const showEditForm = ref(false);
    const { resetAdItem, adCampaignItem } = useAdCampaignItem();
    watch(() => showEditForm.value, function (value) {
      if (!value) {
        resetAdItem();
      }
    });

    function openEditDialog (item: IAdCampaignItem) {
      adCampaignItem.value = item;
      showEditForm.value = true;
    }

    return {
      adHeadersData,
      photoDialog,
      showEditForm,
      adCampaignItem,
      calculateHeight,
      optionsChangeEventHandler,
      calculateCtr,
      openPhotoDialog,
      openEditDialog,
    };
  },
});
